export default __webpack_public_path__ + "static/media/arrow-scroll.3f396d27.svg";